import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { Message } from 'primeng/components/common/message';
import { CreateRewardModel, DropDownSocialLink, Reward, RewardSocialLinksModel, RewardTypeEnum } from '../../../models/inModels/Rewards';
import { TagFileModel } from '../../../models/inModels/TagFileModel';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { RewardsService } from '../../../services/rewards/rewards.service';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-rewards-create',
  templateUrl: './rewards-create.component.html',
  styleUrls: ['./rewards-create.component.css']
})
export class RewardsCreateComponent implements OnInit  {
  model: CreateRewardModel;
  loading = false;
  error: Message[];
  uploading = false;
  rewards;
  tags = false;
  selectedRewardType;
  socialPlatforms = [
    { id: 6, name: 'LinkedIn', url: '' },
    { id: 7, name: 'Facebook', url: '' },
    { id: 8, name: 'Instagram', url: '' },
    { id: 9, name: 'Lemi', url: '' },
    { id: 10, name: 'Twitter', url: '' },
  ];
  socialLinks: DropDownSocialLink[] = [];
  isLoading = true;
  constructor(
    private auth: AuthenticationService,
		private router: Router,
		private service: RewardsService,
		public storageService: StorageService,
    private confirmationService: ConfirmationService) {
    this.model = new CreateRewardModel();
    this.selectedRewardType = { value: RewardTypeEnum.Internal, label: "Internal" };
   
  }
  ngOnInit() { 
    this.loadSocialLinks();
  }
  goBack(): void {
    this.router.navigate(['/rewards']);
  }

 
  save(): void {
    const rewardSocialLinks: RewardSocialLinksModel[] = this.socialPlatforms
        .filter((social) => social.url.trim() !== '')
        .map((social) => ({
            Id: social.id,
            Title: social.name, 
            SocialId: social.id,
            Url: social.url,
        }));

    // Assign the mapped data to the model
    this.model.RewardSocialLinks = rewardSocialLinks;
    this.loading = true;
    this.service.create(this.model).then(
        (result) => {
            this.loading = false;
            console.log("Reward created successfully:", result);
            this.goBack();
        },
        (error) => {
            this.loading = false;
            this.error = [];
            this.error.push({ severity: 'error', summary: 'Error', detail: error.message || 'An error occurred' });
        }
    );
}

  handleImage(event): void {
    var result = this.storageService.handleSuccess(event);
		this.model.LogoId = result.PublicId;
		this.loading = false;
  }

  handleProductImage(event): void {
    var result = this.storageService.handleSuccess(event);
		this.model.ProductPreviewId = result.PublicId;
		this.loading = false;
  }
  handleCoverImage(event): void {
    var result = this.storageService.handleSuccess(event);
		this.model.CoverImageId = result.PublicId;
		this.loading = false;
  }

  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	handleBackgroundImage(event) {
		var result = this.storageService.handleSuccess(event);
		this.model.BackgroundPictureId = result.PublicId;
		this.loading = false;
	}
  handleAboutImage(event) {
		var result = this.storageService.handleSuccess(event);
		this.model.SubBodyImageId = result.PublicId;
		this.loading = false;
	}
  
  
  removeImage(): void {
		this.model.LogoId = null;
		this.loading = false;
  }

  removeProductImage(): void {
    this.model.ProductPreviewId = null;
		this.loading = false;
	}
  removeCoverImage(): void {
    this.model.CoverImageId = null;
		this.loading = false;
	}
	removeBackgroundImage() {
		this.model.BackgroundPictureId = null;
		this.loading = false;
	}
  removeAboutImage(){
    this.model.BackgroundPictureId = null;
		this.loading = false;
  }
  
  initRewardTypeDropDown(event): void {
		this.service.getDropdownList(event).then(
			x => {
				this.rewards = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }
  
  setRewardType(): void {
		this.model.RewardTypeId = this.selectedRewardType.value;
	}
  loadSocialLinks(): void {
		this.service.getSocialLinks()
		  .then(links => {
			this.socialLinks = links;
		  })
		  .catch(error => {
			console.error('Failed to load social links:', error);
		  });
	  }

   
}



// WEBPACK FOOTER //
// ./src/app/components/rewards/rewards-create/rewards-create.component.ts